<div #overlay class="overlay">
    <div class="content center-content">
        <div class="content-container">
            <div class="padding-container">
                <div class="column-flex">
                    <div class="dialog-title">
                        {{ 'vessel.page.release.ownership.dialog.title' | translate }}
                    </div>

                    <div class="assigments-container">
                        <div class="input-container">
                            <div class="radio-button-container" (click)="selectedAssignment = ASSIGNED">
                                <div
                                    class="border-radio-button"
                                    [ngClass]="{ selected: selectedAssignment === ASSIGNED }">
                                    <input
                                        class="radio-button"
                                        type="radio"
                                        name="approvalType"
                                        [checked]="selectedAssignment === ASSIGNED" />
                                </div>
                                <span class="radio-label">
                                    {{ 'vessel.page.release.ownership.dialog.assign.user.option' | translate }}
                                </span>
                            </div>

                            <form class="input-form" *ngIf="approversList">
                                <app-input-select-with-error
                                    [initialValue]="selectedUser"
                                    [legend]="'approval.request.dialog.form.legend'"
                                    [placeholder]="'approval.request.dialog.form.placeholder'"
                                    [optionsArray]="approversList"
                                    [displayKey]="'name'"
                                    [maxLength]="50"
                                    [disabled]="selectedAssignment !== ASSIGNED"
                                    (onInputUpdated)="selectedUser = $event"></app-input-select-with-error>
                            </form>
                        </div>

                        <div class="input-container">
                            <div class="radio-button-container" (click)="selectedAssignment = UNASSIGNED">
                                <div
                                    class="border-radio-button"
                                    [ngClass]="{ selected: selectedAssignment === UNASSIGNED }">
                                    <input
                                        class="radio-button"
                                        type="radio"
                                        name="approvalType"
                                        [checked]="selectedAssignment === UNASSIGNED" />
                                </div>
                                <span class="radio-label">
                                    {{ 'vessel.page.release.ownership.dialog.leave.unassigned.option' | translate }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <app-textarea-with-error
                        class="input-form"
                        [inputValue]="comment"
                        [legend]="'approval.request.dialog.reason.form.comment'"
                        [propertyName]="'comment'"
                        [validatorFunction]="validatorFunction()"
                        (onInputUpdated)="comment = $event"
                        [rows]="9"
                        [maxLength]="COMMENT_MAX_LENGTH"
                    ></app-textarea-with-error>
                </div>

                <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
            </div>
            <div class="buttons-container">
                <div class="cancel button" (click)="clearForm()">
                    {{ 'approval.request.dialog.cancel' | translate }}
                </div>
                <div
                    class="create button"
                    [ngClass]="{ button_disabled: isButtonDisabled() }"
                    (click)="releaseOwnership()">
                    {{ 'approval.request.dialog.submit' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
